import Api from "utils/api";
import { decryptJSON } from "global/security";

function ensurePayload(response, fallbackMessage) {
  if (!response?.success || !response?.data) {
    throw new Error(response?.message || fallbackMessage);
  }

  return decryptJSON(response.data);
}

export async function getCustomersV2() {
  const { response, error } = await Api("/super_admin_v2/customers", "get");

  if (error) {
    throw new Error(error?.message || "Failed to load customers");
  }

  return ensurePayload(response, "Customers are unavailable");
}

export async function getCustomerDetailV2(userId) {
  const { response, error } = await Api(`/super_admin_v2/customers/${userId}`, "get");

  if (error) {
    throw new Error(error?.message || "Failed to load customer detail");
  }

  return ensurePayload(response, "Customer detail is unavailable");
}

export async function resendWorkspaceCreatePasswordV2(userId) {
  const { response, error } = await Api(
    `/super_admin_v2/workspace-users/${userId}/resend-create-password`,
    "post"
  );

  if (error) {
    throw new Error(error?.message || "Failed to send create password email");
  }

  if (!response?.success) {
    throw new Error(response?.message || "Failed to send create password email");
  }

  return response;
}

export async function resendWorkspaceWalletEmailV2(userId) {
  const { response, error } = await Api(
    `/super_admin_v2/workspace-users/${userId}/resend-wallet-email`,
    "post"
  );

  if (error) {
    throw new Error(error?.message || "Failed to send add to wallet email");
  }

  if (!response?.success) {
    throw new Error(response?.message || "Failed to send add to wallet email");
  }

  return response;
}

export async function generateWorkspaceCreatePasswordLinkV2(userId) {
  const { response, error } = await Api(
    `/super_admin_v2/workspace-users/${userId}/generate-create-password-link`,
    "post"
  );

  if (error) {
    throw new Error(error?.message || "Failed to generate create password link");
  }

  return ensurePayload(response, "Create password link is unavailable");
}

export async function generateWorkspaceWalletLinkV2(userId) {
  const { response, error } = await Api(
    `/super_admin_v2/workspace-users/${userId}/generate-wallet-link`,
    "post"
  );

  if (error) {
    throw new Error(error?.message || "Failed to generate add to wallet link");
  }

  return ensurePayload(response, "Add to wallet link is unavailable");
}
